import React from "react";

import { FaGithubAlt, FaLinkedin, FaInstagram } from "react-icons/fa";
import { TbArrowsMinimize, TbArrowsMaximize } from "react-icons/tb";
const BottomNav = ({ iconopen, iconView }) => {
  return (
    <>
      {" "}
      <nav
        aria-label="social links"
        className={`fab-animate z-50 md:hidden  ${
          iconopen ? "open-animate" : ""
        }`}
      >
        <button
          type="button"
          aria-label="social-links"
          onClick={iconView}
          className="z-50 text-5xl font-thin animate-button focus:outline-none"
        >
          {!iconopen ? (
            <TbArrowsMaximize
              aria-label="social-menu-open"
              alt="social-menu-open"
            />
          ) : (
            <TbArrowsMinimize
              alt="social-menu-close"
              aria-label="social-menu-close"
            />
          )}
        </button>
        <div className=" menu-animate">
          <a
            href="https://www.instagram.com/itiwariarun/?igshid=YmMyMTA2M2Y%3D"
            id="instagram page-drawer"
            rel="exteranl noreferrer noopener"
            title="instagram page"
            target="_blank"
            alt="go to instagram page"
          >
            <FaInstagram aria-label="instagram page" />
          </a>
          <a
            href="https://www.Linkedin.com/in/itiwariarun"
            rel="exteranl noreferrer noopener"
            title="linkedin page"
            target="_blank"
            id="linkedin page-drawer"
            alt="go to linkedin"
          >
            <FaLinkedin aria-label="linkedin" />
          </a>
          <a
            href="https://www.github.com/itiwariarun"
            id="gihub page-drawer"
            rel="exteranl noreferrer noopener"
            title="gihub page"
            target="_blank"
            alt="go to github"
          >
            <FaGithubAlt aria-label="github" />
          </a>
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
